import { ADMIN_MODAL_TYPE } from '@data/modalTypes'
import { isEncounterWriteLocked, isEncounterWriteModal, guardEncounterWrite } from '@util'
import { create } from 'zustand'
import type { DOCTOR_MODAL_TYPE } from './DoctorModal'
import type { NURSE_MODAL_TYPE } from './NurseModals'
import { PATIENT_MODAL_TYPE } from './PatientModal'
import type { PHARMACY_MODAL_TYPE } from './PharmacyModal'

type MODAL_TYPE = ADMIN_MODAL_TYPE | DOCTOR_MODAL_TYPE | NURSE_MODAL_TYPE | PHARMACY_MODAL_TYPE | PATIENT_MODAL_TYPE

type AppModal = {
  modal: MODAL_TYPE
  modalProps?: Record<string, any>
}

type Store = {
  activeModal: AppModal[]
  closeModal: (modal: MODAL_TYPE, reset?: () => void) => void
  openModal: (modal: MODAL_TYPE, modalProps: Record<string, any>) => void
}

export const useModalStore = create<Store>(set => ({
  activeModal: [],
  closeModal: (modal, reset) => {
    reset?.()
    set(state => ({
      activeModal: state.activeModal?.filter(m => m.modal !== modal)
    }))
  },
  openModal: (modal, modalProps) => {
    // Block create/update/cancel/delete only — view/details modals still open.
    if (isEncounterWriteLocked() && isEncounterWriteModal(String(modal))) {
      guardEncounterWrite()
      return
    }
    set(({ activeModal }) => ({
      activeModal: [...activeModal?.filter(({ modal: mod }) => mod !== modal), { modal, modalProps }]
    }))
  }
}))
